// extracted by mini-css-extract-plugin
export var compactFilters = "_dm-4";
export var detailImage = "_dm-1";
export var dropdownContainer = "_dm-2";
export var imageContainer = "_dm-0";
export var selectedCard = "_dm-3";